<!-- @format -->
<!-- 资源树 -->

<template>
	<el-tree-select
		ref="treeRef"
		v-model="resValue"
		v-loading="resList.loading"
		:data="resList.data"
		:props="defaultProps"
		default-expand-all
		node-key="objectid"
		highlight-current
		placeholder="请选择资源项"
		filterable
		:filter-node-method="filterNode"
	>
		<template #default="{ data }">
			<el-icon v-if="data.resType === '0'"><Folder /></el-icon>
			{{ data.resName?.length > 12 ? `${data.resName.slice(0, 12)}...` : data.resName }}
			{{ showCount && data.resCount ? `(${data.resCount})` : '' }}
		</template>
	</el-tree-select>
</template>

<script setup lang="ts">
	import type { ElTree } from 'element-plus';
	import { getResList } from '@/api/resource';

	interface Props {
		defaultProps?: Record<string, any>;
		modelValue: string | string[];
		bussinessCode: string; // 业务分类
		showCount?: boolean; // 是否展示count
	}

	const props = withDefaults(defineProps<Props>(), {
		defaultProps: () => ({}),
	});
	const emit = defineEmits(['update:modelValue']);

	// initialValue
	interface ResList {
		loading: boolean; // 是否loading
		data: any[]; // 资源树数据
	}

	// state
	// el-tree-ref
	const treeRef = ref<InstanceType<typeof ElTree>>();

	// tree数据
	const resList = ref<ResList>({
		loading: false,
		data: [],
	});

	const resValue = computed({
		get() {
			return props.modelValue || '';
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});

	// tree-props
	const defaultProps = {
		children: 'children',
		label: 'resName',
		isLeaf: (data: any) => data.resType === '1',
		...props.defaultProps,
	};

	// action

	// tree-filter方法
	const filterNode = (value: string, data) => {
		if (!value) return true;
		return data.resName.toLocaleLowerCase().includes(value.toLocaleLowerCase());
	};

	// 获取resList方法
	const getResLists = () => {
		resList.value.loading = true;
		getResList({ bussinessCode: props.bussinessCode }).then((res) => {
			if (res.code === 200) {
				resList.value = {
					data: res.rows,
					loading: false,
				};
			}
		});
	};

	// mounted
	// 初次渲染时获取数据
	getResLists();
</script>

<style scoped lang="scss"></style>
